import axios from "axios";
import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
class Requester {
    constructor() {
        this.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            withCredentials: true, 
        });

        this.axiosInstance.interceptors.request.use(
            (config) => {
                const csrfToken = this.getCsrfToken();
                const authToken = this.getJwtToken();

                if (csrfToken) {
                    config.headers["X-CSRF-Token"] = csrfToken;
                }

                if (authToken) {
                    config.headers["Authorization"] = `Bearer ${authToken}`;
                }

                return config;
            },
            (error) => Promise.reject(error)
        );

        /*
            this.axiosInstance.interceptors.response.use(
                (response) => response,
                (error) => {
                    if (error.response?.status === 401) {
                        this.removeJwtToken();
                        console.warn("Session expired. Please log in again.");
                        
                        // alert("เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่");
                        // window.location.href = '/login';
                    }else if (error.response?.status === 403) {
                        this.removeJwtToken();
                        console.warn("Session expired. Please log in again.");
                        
                        alert("เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่");
                        window.location.href = '/login';
                    }
                    return Promise.reject(error);
                }
            );
        */

        this.fetchCsrfToken();
    }

    fetchCsrfToken() {
        this.axiosInstance.get("/public/csrf-token")
            .then((response) => {
                const csrfToken = response.data.csrfToken;
                if (csrfToken) {
                    localStorage.setItem("csrfToken", csrfToken);
                }
            })
            .catch((error) => {
                console.error("Error fetching CSRF Token", error);
            });
    }

    getCsrfToken() {
        return localStorage.getItem("csrfToken") || 
               Cookies.get("XSRF-TOKEN") || null;
    }

    getJwtToken() {
        return localStorage.getItem("authToken");
    }

    storeJwtToken(token) {
        localStorage.setItem("authToken", token);
    }

    removeJwtToken() {
        localStorage.removeItem("authToken");
        Cookies.remove("userProfile"); 
    }
}

export default new Requester().axiosInstance;
